import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "d-block pt-2" }
const _hoisted_5 = { class: "form-label fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-start"
}
const _hoisted_9 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormTextAreaClearable = _resolveComponent("FormTextAreaClearable")!
  const _component_CatalogOptions = _resolveComponent("CatalogOptions")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show && _ctx.catalog,
    title: _ctx.t('EditCatalog'),
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('CatalogCode')), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control",
            value: _ctx.catalog.code,
            disabled: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('CatalogDescription')), 1),
          _createVNode(_component_FormTextAreaClearable, {
            modelValue: _ctx.description,
            rows: 3,
            validators: _ctx.validators.description,
            "onUpdate:modelValue": _ctx.onDescriptionUpdate
          }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_CatalogOptions, {
          t: _ctx.t,
          "instance-id": _ctx.instanceId,
          type: _ctx.catalog.type,
          editable: false
        }, null, 8, ["t", "instance-id", "type"]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_ctx.catalog.editable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.catalog.default)
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 0,
                      onClick: _withModifiers(_ctx.onUnMakeDefault, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('RemoveFromFavorites')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_Btn, {
                      key: 1,
                      onClick: _withModifiers(_ctx.onMakeDefault, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('MarkAsFavorite')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Btn, {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
              class: "me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Btn, {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSave()), ["prevent"])),
              disabled: !_ctx.isFormValid,
              primary: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Save', true)), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}